import { backendApi } from '@app/services'

import { Culture } from './types'

export const fetchCultures = async (lang: string) => {
  const { data } = await backendApi.get<Culture[]>(`/cultures/${lang}`)
  return data
}
